// extracted by mini-css-extract-plugin
export default {"wrap":"ForgetMFAUserDialog-wrap","cancelButton":"ForgetMFAUserDialog-cancelButton","forgetButton":"ForgetMFAUserDialog-forgetButton"};